import { render, staticRenderFns } from "./EmailVeryfication.vue?vue&type=template&id=539bffca&"
import script from "./EmailVeryfication.vue?vue&type=script&lang=js&"
export * from "./EmailVeryfication.vue?vue&type=script&lang=js&"
import style0 from "./EmailVeryfication.vue?vue&type=style&index=0&id=539bffca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports